import React from 'react';
import PropTyeps from 'prop-types';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import VolumeSlider from '../../../components/VolumeSlider';

const LooperTrackControl = ({track, onVolumeChange, trackColor, className, vertical}) => (
    <div className={`flexbox m-l-10 absolute flex-column ${className || ''}`}>
        <VolumeSlider
            vertical={vertical}
            volume={track.volume}
            onChange={onVolumeChange}
            color={trackColor}
            label={<FormattedMessage id="looper.looperTrack.volume"/>}/>
    </div>
);

LooperTrackControl.propTypes = {
    onVolumeChange: PropTyeps.func.isRequired,
    className: PropTyeps.string,
    vertical: PropTyeps.bool,
    track: PropTyeps.object
};

export default observer(LooperTrackControl);
